var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"outstock-bar fade-in"},[_vm._v(" สินค้าหมดแล้ว ขออภัยในความไม่สะดวก ")])
}
var staticRenderFns = []

export { render, staticRenderFns }